export default {
  titleCard: '',
  typeSubmit: '',
  cardNewItemActive: false,
  cardListActive: false,
  cardTracingNewItemActive: false,
}
